import { ArrowRight, Phone } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { components } from '@/types/strapi';

interface GetStartedButtonProps {
	cta: components['schemas']['SharedButtonComponent'];
	variant: 'mobile' | 'desktop';
}

export function GetStartedButton({
	cta,
	variant = 'desktop',
}: GetStartedButtonProps) {
	const isPhone = /^[\d\s+-]+$/.test(cta.text || '');
	return (
		<Button
			key={cta.id}
			size="lg"
			className={cn(
				'transition-colors duration-200',
				variant === 'mobile'
					? 'w-full'
					: 'hidden hover:bg-blue-50 md:inline-flex',
			)}
			variant={cta.variant}
			asChild>
			<a href={cta.URL} target={cta.target}>
				<span className="flex items-center gap-2">
					{isPhone && <Phone className="h-4 w-4" />}
					{cta.text}
					{!isPhone && cta.variant === 'primary' && (
						<ArrowRight className="h-4 w-4" />
					)}
				</span>
			</a>
		</Button>
	);
}
